import axios from "axios";

class JoinForm {
    static init($context = null) {
        var selector = "[data-application-type='join']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('join_form_instance')) return;
            $(element).data('join_form_instance', new JoinForm(element))
        });
    }

    //checkDataTimeoutId = null
    //currentProgress = 0
    //lastLoadedDataKey = null

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.$poInput = this.$element.find('[name*="[porg]"]');
        this.$addressInputs = this.$element.find('[name*="[Address:member]"]');
        this.$countryInput = this.$element.find('[name*="[country]"]');
        this.$municipalityInput = this.$element.find('[name*="[municipality]"]');
        this.$cityInput = this.$element.find('[name*="[city]"]');
        this.$streetInput = this.$element.find('[name*="[street]"]');
        this.$buildingInput = this.$element.find('[name*="[building]"]');
        this.$premiseInput = this.$element.find('[name*="[premises]"]');
        this.$postcodeInput = this.$element.find('[name*="[postalCode]"]');
        this.$addressFullInput = this.$element.find('[name*="[addressFull]"]');
        
        
        // this.$poInput.on('change', function (){
        //     this.checkAddressConditions()
        // }.bind(this))
        // this.checkAddressConditions()
    }

    checkAddressConditions(){

        if(!this.$poInput.val()){
            this.makeAddressReadonly(false)
            return;
        }

        //preloader.show();
        axios.get(`${this.basePath()}api/applications/po_address_requirements`, {
            params: {
                project: this.$poInput.val(),
            }
        }).then(response => {
            this.makeAddressReadonly(response.data.readonly || false, response.data.address)
        }).catch(error => {
        }).finally(() => {
            //preloader.hide()
        })
    }
    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }

    makeAddressReadonly(readonly = true, address = null){

        if(!address){
            readonly = false
        }

        this.$addressInputs.each(function (index, el){
            this.makeReadonly($(el), readonly)
        }.bind(this))

        if(readonly && address){
            if(address.country === 'LT'){
                this.$countryInput.val(personData.address.country).trigger('change');
                this.$municipalityInput.val(address.municipality).change()

                if(address.city){
                    this.$cityInput.find('option').remove();
                    this.$cityInput.append(
                        new Option(address.city_title, address.city, false, false)
                    )
                    this.$cityInput.val(address.city).trigger('change');
                }
                if(address.street){
                    this.$streetInput.find('option').remove();
                    this.$streetInput.append(
                        new Option(address.street_title, address.street, false, false)
                    )
                    this.$streetInput.val(address.street).trigger('change');
                }

                if(address.building){
                    this.$buildingInput.find('option').remove();
                    this.$buildingInput.append(
                        new Option(address.address_title, address.building, false, false)
                    )
                    this.$buildingInput.val(address.building).trigger('change');
                }

                if(address.premises){
                    this.$premiseInput.find('option').remove();
                    this.$premiseInput.append(
                        new Option(address.premises_title, address.premises, false, false)
                    )
                    this.$premiseInput.val(address.premises).trigger('change');
                }
                if(address.postcode){
                    this.$postcodeInput.find('option').remove();
                    this.$postcodeInput.append(
                        new Option(address.postcode, address.postcode, false, false)
                    )
                    this.$postcodeInput.val(address.postcode).trigger('change');
                }
            }else{
                this.$countryInput.val('').trigger('change');
                this.$addressFullInput.val(address.address)
            }

        }

    }

    makeReadonly($input, readonly = true){
        $input.attr('readonly', readonly ? 'readonly' : null)
        if($input.hasClass('select2-hidden-accessible')){
            if(readonly){
                $input.data('select2')?.$container.addClass('select2-container--readonly');
            }else{
                $input.data('select2')?.$container.removeClass('select2-container--readonly');
            }

        }
    }
}


if (typeof module === "object" && typeof module.exports === "object"){
    JoinForm.init()
    //node modules support
    module.exports = JoinForm;
}else{
    $(function(){
        JoinForm.init()
    });
}